export const companyTypes = [
  { label: "Corporate", value: "corporate" },
  { label: "Start-up/Scale-up", value: "start-up/scale-up" },
  { label: "Entrepreneurial/Innovative", value: "entrepreneurial/innovative" },
  { label: "Mid-size", value: "mid-size" },
  { label: "Family-owned", value: "family-owned" },
  { label: "Other", value: "other" },
];

export const workEnvironments = [
  {
    label: "Fast-paced, goal-oriented and performance driven",
    value: "fast-paced, goal-oriented and performance driven",
  },
  {
    label: "Creative, energetic and socially engaging",
    value: "creative, energetic and socially engaging",
  },
  {
    label: "Calm, predictable, and cooperative",
    value: "calm, predictable, and cooperative",
  },
  {
    label: "Structured, organized and rule-based",
    value: "structured, organized and rule-based",
  },
];

export const roleOpenOptions = [
  { value: "Replacement of someone", label: "Replacement of someone" },
  { value: "Newly created", label: "Newly created" },
  { value: "Team growth", label: "Team growth" },
];

export const employmentTypes = [
  "Full-time",
  "Part-time",
  "Contractor",
  "Freelancer",
];

export const experienceLevels = [
  { value: "Entry-level", label: "Entry-level" },
  { value: "Professional", label: "Professional" },
  { value: "Expert", label: "Expert" },
  { value: "Leadership", label: "Leadership" },
];

export const skillLevels = ["Beginner", "Intermediate", "Advanced", "Expert"];

export const degreeOptions = [
  {
    value: "Federal Certificate of Proficiency (EFZ / CFC)",
    label: "Federal Certificate of Proficiency (EFZ / CFC)",
  },
  {
    value: "Federal Diploma (Fachausweis)",
    label: "Federal Diploma (Fachausweis)",
  },
  {
    value: "Advanced Federal Diploma (HF)",
    label: "Advanced Federal Diploma (HF)",
  },
  {
    value: "Federal Diploma of Higher Education (Eidg. Dipl. Finanzexperte/in)",
    label: "Federal Diploma of Higher Education (Eidg. Dipl. Finanzexperte/in)",
  },
  {
    value: "Swiss Certified Public Accountant (Dipl. Wirtschaftsprüfer/in)",
    label: "Swiss Certified Public Accountant (Dipl. Wirtschaftsprüfer/in)",
  },
  { value: "Bachelor’s Degree", label: "Bachelor’s Degree" },
  { value: "Master’s Degree", label: "Master’s Degree" },
  { value: "MBA / Executive MBA", label: "MBA / Executive MBA" },
  {
    value: "CAS (Certificate of Advanced Studies)",
    label: "CAS (Certificate of Advanced Studies)",
  },
  {
    value: "DAS (Diploma of Advanced Studies)",
    label: "DAS (Diploma of Advanced Studies)",
  },
  {
    value: "MAS (Master of Advanced Studies)",
    label: "MAS (Master of Advanced Studies)",
  },
  { value: "Doctorate / PhD", label: "Doctorate / PhD" },
];

export const certificationOptions = [
  {
    value: "ACCA - Chartered Certified Accountant",
    label: "ACCA - Chartered Certified Accountant",
  },
  {
    value: "CPA - Certified Public Accountant",
    label: "CPA - Certified Public Accountant",
  },
  {
    value: "CFA - Chartered Financial Analyst",
    label: "CFA - Chartered Financial Analyst",
  },
  {
    value: "CIMA - Chartered Institute of Management Accountants",
    label: "CIMA - Chartered Institute of Management Accountants",
  },
  {
    value: "CMA - Certified Management Accountant",
    label: "CMA - Certified Management Accountant",
  },
  {
    value: "CIA - Certified Internal Auditor",
    label: "CIA - Certified Internal Auditor",
  },
  {
    value: "FRM - Financial Risk Manager",
    label: "FRM - Financial Risk Manager",
  },
  {
    value: "CFP - Certified Financial Planner",
    label: "CFP - Certified Financial Planner",
  },
  {
    value:
      "Treuhänder/in mit eidg. Fachausweis (Certified Fiduciary – Switzerland)",
    label:
      "Treuhänder/in mit eidg. Fachausweis (Certified Fiduciary – Switzerland)",
  },

  {
    value: "PMP - Project Management Professional",
    label: "PMP - Project Management Professional",
  },
  { value: "PRINCE2", label: "PRINCE2" },
  { value: "IPMA", label: "IPMA" },
  { value: "Lean Six Sigma Green Belt", label: "Lean Six Sigma Green Belt" },
  { value: "Lean Six Sigma Black Belt", label: "Lean Six Sigma Black Belt" },
  { value: "Power BI Data Analyst", label: "Power BI Data Analyst" },
  { value: "Tableau Desktop Specialist", label: "Tableau Desktop Specialist" },
  {
    value: "Google Data Analytics Certificate",
    label: "Google Data Analytics Certificate",
  },
  {
    value: "CFA Institute - Certificate in ESG Investing",
    label: "CFA Institute - Certificate in ESG Investing",
  },
  {
    value: "Certificate in Business Analytics",
    label: "Certificate in Business Analytics",
  },
  {
    value: "GRI Certification - Global Reporting Initiative",
    label: "GRI Certification - Global Reporting Initiative",
  },
  {
    value: "IFRS Sustainability Standards Training",
    label: "IFRS Sustainability Standards Training",
  },
  { value: "AgilePM", label: "AgilePM" },
  {
    value: "Scrum Master Certification (PSM / CSM)",
    label: "Scrum Master Certification (PSM / CSM)",
  },
  {
    value: "Digital Finance Certificate",
    label: "Digital Finance Certificate",
  },
  {
    value: "Blockchain in Finance Certification",
    label: "Blockchain in Finance Certification",
  },
];
